import { useState } from "react";

/**
 * Project imagery is first-party G&F work. If a file fails to load we hide the
 * image rather than substituting stock — a placeholder here would misrepresent
 * the client work it sits under.
 *
 * There is deliberately no fade-in. An opacity transition gated on an onLoad
 * flag left cached and lazily-decoded images stuck at opacity 0, so most of the
 * page rendered black. Images now paint as soon as the browser has them; the
 * dark frame behind them means there is no jarring flash to cover.
 */
export const Img = ({
  src,
  alt = "",
  className = "",
  priority = false,
  ...rest
}) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <div className={className} aria-hidden="true" />;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : undefined}
      decoding="async"
      onError={() => setFailed(true)}
      {...rest}
    />
  );
};

export default Img;
